import {useQuery} from "@apollo/client";
import {Table, TableBody, TableCell, TableRow} from "@mui/material";
import FormattedTableHead from "./FormattedTableHead";
import {CheckIcon, CloseIcon} from "./icons";
import {Link} from "./widgets";
import {PersonalUser} from "@/api";
import {PersonalExtensionListDocument, PersonalExtensionListQuery} from "@/queries.generated";
import {defineMessage} from "react-intl";

const getLink = (extension: Pick<PersonalUser, "id">) => `/personal-extensions/${extension.id}`;

export default () => {
    const {data} = useQuery<PersonalExtensionListQuery>(PersonalExtensionListDocument, {fetchPolicy: "no-cache"});

    const extensions = data?.personalUsers || [];

    return (
        <div style={{padding: 20}}>
            <Table>
                <FormattedTableHead
                    cells={[
                        {label: defineMessage({id: "name", defaultMessage: "Name"})},
                        {label: defineMessage({id: "e164", defaultMessage: "E.164"})},
                        {label: defineMessage({id: "shortNumber", defaultMessage: "Short number"})},
                        {label: defineMessage({id: "domain_name", defaultMessage: "Domain name"})},
                        {label: defineMessage({id: "isOwner", defaultMessage: "Owner"})},
                    ]}
                />
                <TableBody>
                    {extensions.map((ext) => (
                        <TableRow key={ext.id}>
                            <TableCell>
                                <Link to={getLink(ext)}>{ext.name}</Link>
                            </TableCell>
                            <TableCell>
                                <Link to={getLink(ext)}>{ext.e164}</Link>
                            </TableCell>
                            <TableCell>
                                <Link to={getLink(ext)}>{ext.shortNumber}</Link>
                            </TableCell>
                            <TableCell>{ext.domain.name}</TableCell>
                            <TableCell>{ext.isOwner ? <CheckIcon /> : <CloseIcon />}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};
